import axios from '@/axios.js'

export default {
  addPermissions({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/admin/permissions", item)
        .then((response) => {
          commit('ADD_PERMISSION', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updatePermissions({ commit }, item) {

    return new Promise((resolve, reject) => {

      axios.put("/admin/permissions/" + item.id, item)
        .then((response) => {
          commit('UPDATE_PERMISSION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchPermissions({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/admin/permissions?sort=code,ASC', {
        params: payload
      })
        .then((response) => {
          commit('SET_PERMISSION', response.data)
          commit('SET_PAGINATION', {
            currentPage: parseInt(response.headers['x-pagination-page']),
            totalPage: parseInt(response.headers['x-pagination-page-count']),
            pageTotal: parseInt(response.headers['x-pagination-count']),
            totalItem: parseInt(response.headers['x-pagination-total']),
          })

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchPermission(context, permissionId) {
    return new Promise((resolve, reject) => {
      axios.get(`/admin/permissions/${permissionId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removePermission({ commit }, permissionId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/admin/permissions/${permissionId}`)
        .then((response) => {
          commit('REMOVE_RECORD', permissionId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
